var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7648 9.06795H18.0936V9.03337H10.5936V12.3667H15.3032C14.6161 14.3071 12.7698 15.7 10.5936 15.7C7.83234 15.7 5.59359 13.4613 5.59359 10.7C5.59359 7.93878 7.83234 5.70003 10.5936 5.70003C11.8682 5.70003 13.0278 6.18087 13.9107 6.96628L16.2678 4.6092C14.7794 3.22212 12.7886 2.3667 10.5936 2.3667C5.9915 2.3667 2.26025 6.09795 2.26025 10.7C2.26025 15.3021 5.9915 19.0334 10.5936 19.0334C15.1957 19.0334 18.9269 15.3021 18.9269 10.7C18.9269 10.1413 18.8694 9.59587 18.7648 9.06795Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22119 6.82128L5.95911 8.8292C6.69994 6.99503 8.49411 5.70003 10.5937 5.70003C11.8683 5.70003 13.0279 6.18087 13.9108 6.96628L16.2679 4.6092C14.7795 3.22212 12.7887 2.3667 10.5937 2.3667C7.39286 2.3667 4.61702 4.17378 3.22119 6.82128Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5936 19.0333C12.7461 19.0333 14.7019 18.2096 16.1806 16.87L13.6015 14.6875C12.7367 15.3452 11.68 15.7009 10.5936 15.7C8.42605 15.7 6.58564 14.3179 5.8923 12.3892L3.1748 14.4829C4.55397 17.1817 7.3548 19.0333 10.5936 19.0333Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.765 9.06779H18.0938V9.0332H10.5938V12.3665H15.3033C14.9747 13.29 14.3826 14.097 13.6004 14.6878L13.6017 14.687L16.1808 16.8695C15.9983 17.0353 18.9271 14.8665 18.9271 10.6999C18.9271 10.1411 18.8696 9.5957 18.765 9.06779Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.e85204f0a824a4127144c5e164393391.svg";
export { ForwardRef as ReactComponent };